<div class="form-wrapper">
  @if (signUpType() == 'email') {
    <form [formGroup]="emailForm">
      <mat-form-field hideRequiredMarker="true">
        <mat-label>E-mailadres</mat-label>
        <input matInput autocomplete="email" type="email" formControlName="email" />
        @if (emailForm.controls.email.hasError('required')) {
          <mat-error>E-mailadres is verplicht.</mat-error>
        }
        @if (emailForm.controls.email.hasError('emailValidator')) {
          <mat-error>Vul een geldig e-mailadres in.</mat-error>
        }
        @if (
          emailForm.controls.email.hasError('already-has-org') ||
          emailForm.controls.email.hasError('user-already-exists')
        ) {
          <mat-error>Dit e-mailadres is al in gebruik.</mat-error>
        }
      </mat-form-field>
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Wachtwoord</mat-label>
        <input
          matInput
          autocomplete="new-password"
          type="{{ showPasswords() ? '' : 'password' }}"
          formControlName="password"
        />
        <button
          type="button"
          matSuffix
          mat-icon-button
          [attr.aria-label]="showPasswords() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien'"
          matTooltip="{{ showPasswords() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien' }}"
          (click)="showPasswords.set(!showPasswords())"
        >
          <mat-icon>{{ showPasswords() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (emailForm.controls.password.hasError('required')) {
          <mat-error>Wachtwoord is verplicht.</mat-error>
        }
        @if (emailForm.controls.password.hasError('minlength')) {
          <mat-error
            >Het wachtwoord moet minimaal {{ emailForm.controls.password.errors?.minlength.requiredLength }} karakters
            bevatten.</mat-error
          >
        }
      </mat-form-field>
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Wachtwoord bevestigen</mat-label>
        <input
          matInput
          autocomplete="new-password"
          type="{{ showPasswords() ? '' : 'password' }}"
          formControlName="passwordConfirm"
        />
        <button
          type="button"
          matSuffix
          mat-icon-button
          [attr.aria-label]="showPasswords() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien'"
          matTooltip="{{ showPasswords() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien' }}"
          (click)="showPasswords.set(!showPasswords())"
        >
          <mat-icon>{{ showPasswords() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (emailForm.controls.passwordConfirm.hasError('required')) {
          <mat-error>Wachtwoord is verplicht.</mat-error>
        }
        @if (emailForm.controls.passwordConfirm.hasError('minlength')) {
          <mat-error>
            Het wachtwoord moet minimaal
            {{ emailForm.controls.passwordConfirm.errors?.minlength.requiredLength }} karakters bevatten.
          </mat-error>
        }
      </mat-form-field>
      <div class="action-button-wrapper">
        <button type="button" mat-stroked-button routerLink="/auth"><mat-icon>arrow_back</mat-icon> Terug</button>
        <button
          mat-flat-button
          [class.spinner]="awaitingResponse()"
          [disabled]="awaitingResponse()"
          (click)="signUp('email')"
        >
          Volgende
        </button>
      </div>
    </form>
  }

  <!-- phone form -->
  @if (signUpType() == 'phone' && phoneSignUpStatus() !== 'verification') {
    <form [formGroup]="phoneForm">
      <div
        class="tel-input-wrapper"
        [ngClass]="
          (phoneForm.controls.phoneNumber.hasError('validatePhoneNumber') && phoneForm.controls.phoneNumber.touched) ||
          phoneForm.controls.phoneNumber.hasError('user-not-found') ||
          (phoneSubmitted() && !phoneForm.controls.phoneNumber.value)
            ? 'tel-input-error'
            : ''
        "
      >
        <ngx-intl-tel-input
          [cssClass]="'tel-input-input'"
          [preferredCountries]="[CountryISO.Netherlands]"
          [enableAutoCountrySelect]="false"
          [enablePlaceholder]="true"
          customPlaceholder="Mobiel telefoonnummer"
          [searchCountryFlag]="false"
          [selectFirstCountry]="false"
          [selectedCountryISO]="CountryISO.Netherlands"
          [separateDialCode]="true"
          [phoneValidation]="true"
          name="phone"
          formControlName="phoneNumber"
          matInput
          (keyup.enter)="signUp('phone')"
        >
        </ngx-intl-tel-input>
        @if (phoneSubmitted() && !phoneForm.controls.phoneNumber.value) {
          <mat-error class="phone-error">Mobiel telefoonnummer is verplicht.</mat-error>
        }
        @if (phoneForm.controls.phoneNumber.hasError('validatePhoneNumber') && phoneForm.controls.phoneNumber.touched) {
          <mat-error class="phone-error">Vul een geldig mobiel telefoonnummer in.</mat-error>
        }
        @if (
          phoneForm.controls.phoneNumber.hasError('already-has-org') ||
          phoneForm.controls.phoneNumber.hasError('user-already-exists')
        ) {
          <mat-error class="phone-error">Dit mobiele telefoonnummer is al in gebruik.</mat-error>
        }
        @if (
          !(
            (phoneForm.controls.phoneNumber.hasError('validatePhoneNumber') &&
              phoneForm.controls.phoneNumber.touched) ||
            phoneForm.controls.phoneNumber.hasError('already-has-org') ||
            phoneForm.controls.phoneNumber.hasError('user-already-exists') ||
            (phoneSubmitted() && !phoneForm.controls.phoneNumber.value)
          )
        ) {
          <mat-error class="phone-error-placeholder">.</mat-error>
        }
      </div>
      <div class="action-button-wrapper">
        <button type="button" mat-stroked-button routerLink="/auth"><mat-icon>arrow_back</mat-icon> Terug</button>
        <button
          type="button"
          mat-flat-button
          [class.spinner]="awaitingResponse()"
          [disabled]="awaitingResponse()"
          (click)="signUp('phone')"
        >
          Volgende
        </button>
      </div>
    </form>
  }

  <!-- verification form -->
  @if (signUpType() == 'phone' && phoneSignUpStatus() == 'verification') {
    <form [formGroup]="verificationForm">
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Verificatie code</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="code" />
        @if (verificationForm.controls.code.hasError('required')) {
          <mat-error>Je moet een verificatie code invullen.</mat-error>
        }
        @if (verificationError) {
          <mat-error>Er is iets misgegaan. Neem contact op met de helpdesk.</mat-error>
        }
      </mat-form-field>
      <div class="action-button-wrapper">
        <button mat-stroked-button (click)="goBackFromVerification()"><mat-icon>arrow_back</mat-icon> terug</button>
        <button
          mat-flat-button
          [class.spinner]="awaitingResponse()"
          [disabled]="awaitingResponse()"
          (click)="verifyLoginCode()"
        >
          Verifiëren
        </button>
      </div>
    </form>
  }
</div>

@if (phoneSignUpStatus() !== 'verification') {
  <div class="alternative-logins">
    <div class="alternative-sub-title">Of registreer met</div>
    <div class="alternate-login-button-wrapper">
      @if (signUpType() !== 'email') {
        <button type="button" mat-stroked-button class="alternate-login-button" (click)="signUpType.set('email')">
          <mat-icon>mail</mat-icon>E-mailadres
        </button>
      }
      @if (signUpType() !== 'phone') {
        <button type="button" mat-stroked-button class="alternate-login-button" (click)="signUpType.set('phone')">
          <mat-icon>call</mat-icon>Telefoonnummer
        </button>
      }
      <button mat-stroked-button class="alternate-login-button" (click)="googleLogin()">
        <div class="alternate-login-button-text-wrapper google-login">
          <img src="../../../../assets/images/google.png" alt="Google logo" />
          Google
        </div>
      </button>
    </div>
  </div>
}

@if (captcha()) {
  <div id="recaptcha-container"></div>
}
